<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="brand">
        <img src="/assets/images/paysol_logo.png" alt="Paysol" />
        <div class="lang-wrap"><LanguageToggle /></div>
        <h2>{{ t('register.title') }}</h2>
        <p>{{ t('register.sub') }}</p>
      </div>
      <form @submit.prevent="submit">
        <label>{{ t('register.businessName') }}</label>
        <input v-model="form.name" required />
        <label>{{ t('register.businessType') }}</label>
        <select v-model="form.businessType">
          <option value="retail">{{ t('register.typeRetail') }}</option>
          <option value="restaurant">{{ t('register.typeRestaurant') }}</option>
          <option value="service">{{ t('register.typeService') }}</option>
          <option value="mixed">{{ t('register.typeMixed') }}</option>
        </select>
        <div class="row">
          <div>
            <label>{{ t('register.city') }}</label>
            <input v-model="form.city" />
          </div>
          <div>
            <label>{{ t('common.phone') }}</label>
            <input v-model="form.phone" placeholder="0712345678" />
          </div>
        </div>
        <label>{{ t('register.ownerName') }}</label>
        <input v-model="form.adminName" required />
        <label>{{ t('register.emailForSignIn') }}</label>
        <input v-model="form.email" type="email" required />
        <label>{{ t('register.passwordMin') }}</label>
        <input v-model="form.password" type="password" minlength="8" required />
        <button type="submit" class="primary full" :disabled="loading">
          {{ loading ? t('register.creating') : t('register.createBusiness') }}
        </button>
        <p class="err" v-if="error">{{ error }}</p>
        <p class="ok"  v-if="success">{{ success }}</p>
      </form>
      <div class="foot">
        <router-link to="/login">{{ t('register.alreadyHaveAccount') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { paysol } from '@/api';
import { t } from '@/i18n';
import LanguageToggle from '@/i18n/LanguageToggle.vue';

export default {
  name: 'Register',
  components: { LanguageToggle },
  data() {
    return {
      localeTick: 0,
      form: { name: '', businessType: 'retail', city: '', phone: '', adminName: '', email: '', password: '' },
      loading: false, error: '', success: ''
    };
  },
  mounted() {
    this._onLoc = () => { this.localeTick++; };
    window.addEventListener('paysol-locale-changed', this._onLoc);
  },
  beforeUnmount() {
    if (this._onLoc) window.removeEventListener('paysol-locale-changed', this._onLoc);
  },
  methods: {
    t(key, vars) { this.localeTick; return t(key, vars); },
    async submit() {
      this.error = ''; this.success = ''; this.loading = true;
      try {
        const { data } = await axios.post(paysol, { function: 'registerTenant', ...this.form });
        if (!data.success) { this.error = data.message; return; }
        this.success = data.message + ' Redirecting…';
        setTimeout(() => this.$router.push('/login'), 1500);
      } catch (e) {
        this.error = e.response?.data?.message || 'Registration failed.';
      } finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.auth-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; }
.auth-card { width: 100%; max-width: 480px; background: var(--paysol-card); border: 1px solid var(--paysol-line); border-radius: 10px; padding: 28px; }
.brand { text-align: center; margin-bottom: 20px; position: relative; }
.brand img { height: 54px; filter: brightness(1.1); }
.lang-wrap { position: absolute; top: 0; right: 0; }
.brand h2 { margin: 12px 0 4px; font-size: 20px; }
.brand p { color: var(--paysol-muted); font-size: 13px; margin: 0; }
form label { margin-top: 12px; }
.row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
button.full { width: 100%; margin-top: 20px; padding: 12px; }
.err { color: var(--paysol-danger); font-size: 13px; margin-top: 12px; text-align: center; }
.ok  { color: var(--paysol-success); font-size: 13px; margin-top: 12px; text-align: center; }
.foot { text-align: center; margin-top: 16px; font-size: 12px; }
</style>
